import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ContentCard } from '../../layout/ContentCard';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ChainForm from './ChainForm';

const ChainFormPage = () => {
  const { id } = useParams();
  const chainId = Number(id);
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:chains.create.title')} />
      <ContentCard header={t(`pages:chains.${id ? 'update' : 'create'}.title`)} maxWidth={{ base: 'full', xl: '100%' }}>
        <ChainForm chainId={chainId} />
      </ContentCard>
    </ContentLayout>
  );
};

export default ChainFormPage;
